import React, {FC} from 'react'
import {UseFormRegister, FieldErrors} from 'react-hook-form'
type InputProps = {
  name: string
  textPlaceholder?: string
  register: UseFormRegister<any>
  errors: FieldErrors
  disabled?: boolean
}

const InputTextArea: FC<InputProps> = ({
  name,
  textPlaceholder,
  register,
  errors,
  disabled,
  ...props
}) => {
  return (
    <div className='sdx_form_input'>
      <textarea
        className='form-control sdx-centra-input-form'
        {...register(name)}
        placeholder={textPlaceholder}
        disabled={disabled}
        {...props}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputTextArea
